export default function ExemploEstrategia() {
  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">

        {/* Eyebrow */}
        <p className="text-center text-xs sm:text-sm font-semibold tracking-widest text-teal-600 uppercase mb-3 sm:mb-4">
          Exemplo de estratégia ensinada no protocolo
        </p>

        {/* Card principal */}
        <div className="border border-gray-200 rounded-2xl overflow-hidden">

          {/* Cabeçalho situação */}
          <div className="bg-teal-600 px-6 py-4">
            <p className="text-white font-semibold text-base sm:text-lg">
              Situação: recusa de banho
            </p>
          </div>

          <div className="divide-y divide-gray-100">

            {/* O que muitas pessoas fazem */}
            <div className="px-6 py-6 bg-red-50/50">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-close-circle-line text-red-500 text-xl"></i>
                </div>
                <p className="text-gray-800 font-semibold text-sm sm:text-base">
                  O que muitas pessoas fazem
                </p>
              </div>
              <div className="ml-8">
                <p className="text-gray-500 text-xs sm:text-sm uppercase tracking-wide mb-2 font-medium">Abordagem comum:</p>
                <p className="text-gray-800 text-base sm:text-lg font-medium italic border-l-4 border-red-300 pl-4 mb-3">
                  &ldquo;Vamos tomar banho agora.&rdquo;
                </p>
                <p className="text-red-600 text-sm font-medium">
                  Isso pode aumentar a resistência.
                </p>
              </div>
            </div>

            {/* O que o protocolo ensina */}
            <div className="px-6 py-6 bg-teal-50/40">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-line text-teal-600 text-xl"></i>
                </div>
                <p className="text-gray-800 font-semibold text-sm sm:text-base">
                  O que o protocolo ensina
                </p>
              </div>
              <div className="ml-8">
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-4">
                  Dividir a tarefa em micro-passos simples, conduzindo o paciente com previsibilidade e calma.
                </p>
                <div className="flex items-center gap-3 bg-teal-600 rounded-xl px-4 py-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-double-line text-white text-lg"></i>
                  </div>
                  <p className="text-white text-sm sm:text-base font-medium">
                    Isso reduz tensão e aumenta colaboração.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}
